import { all, takeLatest, takeEvery } from 'lib/redux';
import {
  LOAD_BILLING_INFO,
  LOAD_BILLING_ACCOUNT_CONTEXT,
  BILLING_INFO_SUBMIT,
  LOAD_PAYMENT_METHODS,
  SET_PAYMENT_METHOD_DEFAULT,
  REMOVE_PAYMENT_METHOD,
} from 'constants/ActionTypes';
import {
  loadBillingInformationPageSaga,
  loadBillingAccountContextSaga,
  submitBillingInfoSaga,
  loadPaymentMethodsSaga,
  setPaymentMethodDefaultSaga,
  removePaymentMethodSaga,
} from './BillingInformation.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_BILLING_INFO, loadBillingInformationPageSaga),
    // #genai Phase 2 — deep-link account-context hydration for the Add-Card / Add-ACH routes.
    takeLatest(LOAD_BILLING_ACCOUNT_CONTEXT, loadBillingAccountContextSaga),
    takeLatest(BILLING_INFO_SUBMIT, submitBillingInfoSaga),
    // #genai Phase 2 — unified saved payment methods list.
    takeLatest(LOAD_PAYMENT_METHODS, loadPaymentMethodsSaga),
    takeEvery(SET_PAYMENT_METHOD_DEFAULT, setPaymentMethodDefaultSaga),
    takeEvery(REMOVE_PAYMENT_METHOD, removePaymentMethodSaga),
  ]);
}
